try {
  window.$ = window.jQuery = require('jquery');

  require('bootstrap/js/dist/util');
  require('bootstrap/js/dist/modal');
  require('bootstrap/js/dist/collapse');

  // had to wait before adding push
  // to avoid processing before .pushy elements
  // are ready
  setTimeout(function () {
    require('@cmyee/pushy/js/pushy');
  }, 500);
} catch (e) {
  console.log(e);
}



// WEBPACK FOOTER //
// ./assets/js/app.js